import { render } from "./FlowViewContentActivity.vue?vue&type=template&id=4ce43e5a&scoped=true"
import script from "./FlowViewContentActivity.vue?vue&type=script&lang=js"
export * from "./FlowViewContentActivity.vue?vue&type=script&lang=js"

import "./FlowViewContentActivity.vue?vue&type=style&index=0&id=4ce43e5a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4ce43e5a"

export default script